const serverAddress = 'https://backend.niranjanaswami.net'
const frontEndAddress = 'https://www.niranjanaswami.net'
// const serverAddress = 'http://localhost:4000'
// const frontEndAddress = 'http://localhost:3000'
const userIndex = 'users_prod'

module.exports = { serverAddress, frontEndAddress, userIndex }
